const InventorInfos = Vue.component('inventorinfos', {
    template: `
        <div>
            <div class="row title">
                <h4>
                    {{ $language.inventor }}: {{ inventor }}
                </h4>
                <a class="snapshotLink" :href="$setupPath + '../inventorSnapshot/public/?inventor=' + encodeURI(inventor)" target="_blank" title="Link to the full snapshot">
                    Snapshot <img :src="$setupPath + 'components/images/logos/analytics/favicon.ico'" alt="snapshot logo">
                </a>
            </div>
            <div class="main" id="inventorInfos">
                <div class="row">
                    <div class="col-md-8 summary">
                        <div class="row" v-for="(data, field) in inventorData.details" v-if="data && field !== 'latin' && data !== '  '">
                            <div class="col-4">
                                <b v-if="field !== 'assumedJurisdiction'">
                                    {{ field }}
                                </b>
                                <b v-else>
                                    Assumed jurisdiction
                                </b>
                            </div>
                            <div class="col-8" v-if="field !== 'assumedJurisdiction'">
                                {{ data }}
                            </div>
                            <div class="col-8" v-else>
                                {{ $countries.codes[data] + ' (' + data + ')' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <hr />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6" id="companiesChart"></div>
                    <div class="col-lg-6" id="yearsChart"></div>
                </div>
            </div>
        </div>
    `,

    data: function() {
        return {
            inventorData: {}
        };
    },
    watch: {
        inventor: function(newInventor, oldInventor) {
            this.onNewInventor();
        }
    },

    computed: {
        inventor() {
            return this.$route.params.inventor;
        },
        family() {
            return this.$route.params.family;
        }
    },

    mounted: function() {

        this.onNewInventor();

    },

    methods: {
        onNewInventor: function() {

            var _this = this;

            this.$store.commit('changeLoadedInventor', this.inventor);

            if (!this.$store.state.inventorInfos[this.inventor]) {

                axios.get('?page=getData&action=inventor', {
                        params: {
                            inventor: _this.inventor
                        }
                    })
                    .then(function(response) {

                        _this.inventorData = response.data;
                        _this.$store.commit('storeInventorInfos', {
                            inventor: _this.inventor,
                            data: response.data
                        })
                        _this.drawChart();

                    })
                    .catch(function(err) {
                        console.log(err);
                    });

            } else {
                this.inventorData = this.$store.state.inventorInfos[this.inventor];
                this.drawChart();
            }


        },

        drawChart: function() {

            Highcharts.setOptions({
                colors: ['#afd8f8', '#f6bd10', '#8cbb02', '#ff8f48', '#028f8f', '#d64848', '#8f488f', '#5a8629', '#b4ab03', '#038fd6', '#9e0b10', '#a287bf', '#cd6904', '#fdc78b', '#ada205', '#f2707f', '#fff205', '#0558a8', '#f79721', '#cd3805']
            });


            //make the companies data usable in highcharts
            var companiesData = [];
            var companies = [];

            this.inventorData.companies.forEach(function(company) {
                companiesData.push({
                    y: company.total,
                    name: company.assignee
                });
                companies.push(company.assignee);
            });

            Highcharts.chart('companiesChart', {
                chart: {
                    type: 'bar',
                    renderTo: 'container'
                },

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },

                title: {
                    text: this.$language.topCompanies,
                    useHTML: true
                },

                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                xAxis: {
                    title: {
                        text: this.$language.companies
                    },
                    ceiling: 4,
                    categories: companies,

                },

                yAxis: {
                    allowDecimals: false,
                    min: 0,
                    title: {
                        text: this.$language.applications,
                        align: 'high'
                    },

                    labels: {
                        overflow: 'justify'
                    }
                },

                navigation: {
                    buttonOptions: {
                        enabled: true
                    }
                },

                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true,
                            allowOverlap: true

                        }
                    }
                },

                legend: {
                    enabled: false

                },

                credits: {
                    enabled: false
                },

                series: [{
                    name: this.$language.applications,
                    colorByPoint: true,
                    data: companiesData
                }]
            });

            //make the year data usable in highcharts
            var applicationsData = [];
            var grantsData = [];
            var start = [];

            for (var year in this.inventorData.years) {
                if (this.inventorData.years.hasOwnProperty(year)) {
                    start.push(year);
                    applicationsData.push([year, this.inventorData.years[year].applications]);
                    grantsData.push([year, this.inventorData.years[year].grants]);
                }
            }

            Highcharts.chart('yearsChart', {
                chart: {
                    type: 'spline'
                },

                title: {
                    text: this.$language.appNGrant,
                    useHTML: true
                },

                exporting: {
                    buttons: {
                        contextButton: {
                            symbol: 'url(./img/export.png)',
                            width: 24,
                            symbolX: 19.5,
                            symbolY: 18.5
                        }
                    }
                },
                subtitle: {
                    text: '<span class="noDisplay"></span>',
                    useHTML: true
                },

                navigation: {
                    buttonOptions: {
                        enabled: true
                    }
                },

                yAxis: {
                    allowDecimals: false,
                    title: {
                        text: this.$language.appNGrant,
                    }
                },

                xAxis: {
                    //only show data for the last 10 years
                    min: (new Date).getFullYear() - 10
                },

                plotOptions: {
                    series: {
                        pointStart: parseInt(start[0])
                    }
                },


                legend: {
                    enabled: false
                },

                credits: {
                    enabled: false
                },

                series: [{
                    name: this.$language.applications,
                    data: applicationsData

                }, {
                    name: this.$language.grants,
                    data: grantsData
                }]
            });

            this.$store.commit('hideLoading');

        }
    }
});
